import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


@NgModule({
  imports: [RouterModule.forChild([
    { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./central-cliente-pacote-listar/central-cliente-pacote-listar.module').then(m => m.CentralClientePacoteListarModule) },
    { path: 'detalhar', data: { breadcrumb : 'Detalhar' }, loadChildren: () => import('./central-cliente-pacote-detalhar/central-cliente-pacote-detalhar.module').then(m => m.CentralClientePacoteDetalharModule) },
  ])],
  exports: [RouterModule]
})
export class CentralClientePacoteRoutingModule { }
